

















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { BLink, BIcon, BIconArrowRight, BIconArrowLeft } from "bootstrap-vue";
@Component({
  components: {
    BLink,
    BIcon,
    BIconArrowRight,
    BIconArrowLeft,
  },
})
export default class NextPrevBtn extends Vue {
  protected boolPrev = false;
  protected boolNext = false;
  @Prop() protected readonly nxtprevList!: {
    BoolPrev: boolean;
    BoolNext: boolean;
    PrevImage: string;
    NextImage: string;
    PrevLink: string;
    NextLink: string;
  };
}
